import ActionTypes from "modules/documents/constants/action_types";

const CHANNEL_NAME = "applied-amendments-sync";

const SYNCED_ACTION_TYPES = [
  ActionTypes.DOCUMENT_ISSUE_UPDATE_APPLIED_AMENDMENTS.SUCCESS,
  ActionTypes.DOCUMENT_ISSUE_REMOVE_APPLIED_AMENDMENTS.SUCCESS,
];

export default function appliedAmendmentsBroadcastMiddleware() {
  const channel =
    "BroadcastChannel" in self ? new self.BroadcastChannel(CHANNEL_NAME) : null;

  return store => {
    if (channel) {
      channel.onmessage = event => {
        const {type, payload} = event.data || {};
        if (payload && SYNCED_ACTION_TYPES.includes(type)) {
          store.dispatch({type, payload, meta: {fromBroadcast: true}});
        }
      };
    }

    return next => action => {
      if (
        channel &&
        action &&
        !action.meta?.fromBroadcast &&
        SYNCED_ACTION_TYPES.includes(action.type)
      ) {
        try {
          channel.postMessage({type: action.type, payload: action.payload});
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error("BroadcastChannel\n", error);
        }
      }
      return next(action);
    };
  };
}
